import {
  findIndexByPropertyValue
} from 'utilities/collection';

export function determineFieldLabel(fields) {

  let position = fields.length;

  let name = `Sample field - ${position}`;

  while (findIndexByPropertyValue(fields, 'label', name) !== -1) {

    position++;
    name = `Sample field - ${position}`;

  }

  return name;

}